import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_COMMON from "./KAMPYLE_COMMON";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import KAMPYLE_VIEW from "./KAMPYLE_VIEW";
import MDIGITAL_LOCALIZATION from "./MDIGITAL_LOCALIZATION";

  function createFormContainer() {
    var formSpanPlacer = KAMPYLE_UTILS.getOrCreateWrapperContainer(KAMPYLE_CONSTANT.IFRAME_SETTINGS.LIGHTBOX.WRAPPER_ID);
    var divContainer = Object.assign(document.createElement('div'), {
      id: 'kampyleFormContainer'
    });
    var containerStyle = {
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        position: 'fixed',
        visibility: 'hidden',
        display: 'table',
        backgroundColor: 'rgba(102,102,102,0.4)',
        zIndex: '99999999',
        webkitOverflowScrolling: 'touch'
    };
    KAMPYLE_UTILS.setElementStyle(divContainer, containerStyle,true);
    var divElem1 = document.createElement('div');
    divElem1.id = 'kampyleFormContainer';
    var spinnerContainer = createSpinnerElement();
    var divElem2 = document.createElement('div');
    divElem2.id = 'kampyleFormModal';

    KAMPYLE_UTILS.setElementStyle(divElem2, {
      zIndex: '99999999',
      webkitOverflowScrolling: 'touch'
    }, true);
    divElem1.appendChild(spinnerContainer);
    divElem1.appendChild(divElem2);
    divContainer.appendChild(divElem1);
    formSpanPlacer.appendChild(divContainer);
    KAMPYLE_UTILS.setSpinnerStyle(spinnerContainer, KAMPYLE_CONSTANT.SPINNER_SETTINGS.SIZE.LARGE);
    
    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_WCAG_PREPEND_SURVEY)) {
      document.body.prepend(formSpanPlacer);
    } else {
      document.body.appendChild(formSpanPlacer);
    }
  }

  function createInviteIframeContainer(data) {
    var inviteSpanPlacer =  KAMPYLE_UTILS.getOrCreateWrapperContainer(KAMPYLE_CONSTANT.IFRAME_SETTINGS.INVITATION.WRAPPER_ID);
    var device = KAMPYLE_DATA.getMemoryData('kampyleDevice');
    var shouldAdjustToZoom = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_ZOOM_WCAG_REFLOW) && device === 'desktop';
    var divContainer = Object.assign(document.createElement('div'), {
      id: 'kampyleInviteContainer'
    });
    KAMPYLE_UTILS.setElementStyle(divContainer, {
      top: '0',
      left: '0',
      width: shouldAdjustToZoom ? '100vw' : '100%',
      height: shouldAdjustToZoom ? '100vh' : '100%',
      position: 'fixed',
      visibility: 'hidden',
      display: 'none',
      backgroundColor: 'rgba(22,22,22,0.5)',
      zIndex: '99999999',
      overflow: shouldAdjustToZoom ? 'hidden' : 'auto'
    }, true);
    var spinnerContainer = createSpinnerElement();
    var divElem1 = document.createElement('div');
    divElem1.id = 'kampyleInviteModal';
    KAMPYLE_UTILS.setElementStyle(divElem1, {
      overflow: 'hidden',
      margin: '0 auto',
      height: data.inviteData.inviteHeight,
      width: data.inviteData.inviteWidth,
      position: 'relative',
      zIndex: '99999999',
      webkitBoxShadow: '0 0 10px rgba(0,0,0,0.4)',
      mozBoxShadow: '0 0 10px rgba(0,0,0,0.4)',
      boxShadow: '0 0 10px rgba(0,0,0,0.4)',
      top: shouldAdjustToZoom ? '50%' : '25%',
      transform: shouldAdjustToZoom ? 'translateY(-50%)' : 'none',
      maxHeight: shouldAdjustToZoom ? '100vh' : 'unset',
      maxWidth: shouldAdjustToZoom ? '100vw' : 'unset',
    });
    divContainer.appendChild(divElem1);
    divContainer.appendChild(spinnerContainer);
    inviteSpanPlacer.appendChild(divContainer);
    KAMPYLE_UTILS.setSpinnerStyle(spinnerContainer, KAMPYLE_CONSTANT.SPINNER_SETTINGS.SIZE.LARGE);

    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_PREPEND_SURVEY)) {
      document.body.prepend(inviteSpanPlacer);
    } else {
      document.body.appendChild(inviteSpanPlacer);
    }
  }

  function getErrorModal(
    noJsonModalId,
    errorModalLang,
    errorMessageTitle,
    errorMessageBody,
    errorMessageClose
  ) {
    
    var errorModal = document.createElement("div");

    var errorModalAttributes = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.NEW_MODAL_DIALOGS) ? { id: noJsonModalId } : {
      tabIndex: 0,
      id: noJsonModalId,
      role: "alertdialog",
      'aria-modal': true,
      'aria-labelledby': 'title-no-json-modal',
      'aria-describedby': 'description-no-json-modal',
      lang: errorModal
    }

    KAMPYLE_UTILS.addAttributesOnElement(errorModal, errorModalAttributes);

    KAMPYLE_UTILS.setElementStyle(errorModal, {
      position: 'relative',
      textAlign: 'center',
      backgroundColor: 'rgba(255,255,255, 1)',
      margin: KAMPYLE_DATA.getMemoryData('context') === 'preview' ? '100px auto 2% auto' : '5% auto 2% auto',
      border: '1px solid #cccccc',
      boxShadow: '8px 10px 58px 2px rgba(64, 64, 74, 0.56)',
      color: '#2C3548',
      fontFamily: 'helvetica',
      height: '500px',
      width: KAMPYLE_DATA.isMobile() ? '98%' : "450px"
    });

    var closeButton = getErrorModalCloseButton(errorMessageClose, errorModalLang);
    var backgroundImage = getErrorModalBackgroundImage()
    var title = getErrorModalTitle(errorMessageTitle);
    var description = getErrorModalDescription(errorMessageBody);

    errorModal.appendChild(closeButton);
    errorModal.appendChild(backgroundImage);
    errorModal.appendChild(title);
    errorModal.appendChild(description);
    return errorModal;
  }

  function getVerticalButton(formData) {
    var buttonText = KAMPYLE_VIEW.getButtonText(formData);
    var direction = 'kampyle_' + formData.buttonData.position;
    var buttonElement = document.createElement('button');
    var shouldAdjustToZoom = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_ZOOM_WCAG_REFLOW) && KAMPYLE_UTILS.getNestedPropertyValue(formData, 'urlVersion');
    var multiplier = 1;
    if (shouldAdjustToZoom) {
      var zoomMetrics = KAMPYLE_UTILS.getZoomedIn();
      KAMPYLE_DATA.setMemoryData('kampylePageZoom', zoomMetrics.zoom);
      multiplier = zoomMetrics.isZoomedIn ? getMultiplier() : 1;
    }
    var width = 125 * multiplier;
    var height = 35 * multiplier;
    var fontSize = 14 * multiplier;
    var side = -45 * multiplier;
    var VpHeight = window.innerHeight;
    var buttonPosition = VpHeight * 0.55 - width;

    KAMPYLE_UTILS.addAttributesOnElement(buttonElement, {
      id: 'nebula_div_btn',
      alt: buttonText,
      tabIndex: "0",

      class: 'kampyle_vertical_button ' + direction + ' ' + KAMPYLE_VIEW.getWCAGClass()
    });

    KAMPYLE_UTILS.setElementStyle(buttonElement, {
      backgroundColor: 'transparent',
      height: 'auto',
      minHeight: height + 'px',
      maxHeight: height + 'px',
      width: width + 'px',
      minWidth: width + 'px',
      maxWidth: width + 'px',
      padding: 0
    }, false);
    KAMPYLE_UTILS.setElementStyle(buttonElement, {
      fontFamily: 'Open Sans, sans-serif',
      cursor: 'pointer',
      position: 'fixed',
      bottom: buttonPosition + 'px',
      border: "none",
      zIndex: '99999990',
      height: height + 'px',
      '-ms-transform': 'rotate(90deg)',
      '-webkit-transform': 'rotate(90deg)',
      transform: 'rotate(90deg)'
    });
    if (KAMPYLE_DATA.isFeatureEnabled(KAMPYLE_CONSTANT.FEATURE_FLAGS.WCAG)) {
      KAMPYLE_UTILS.addWcagStyleOnFocus(buttonElement);
    } else {
      KAMPYLE_UTILS.setElementStyle(buttonElement, {
        outline: 'none'
      }, false);
    }
    buttonElement.style[formData.buttonData.position] = side + 'px';
    var divElement = document.createElement('div');
    divElement.setAttribute('class', 'kampyle_button');
    var styleForRadius = formData.buttonData.position === 'left' ? '3px 3px 0 0' : '0 0 3px 3px';
    KAMPYLE_UTILS.setElementStyle(divElement, {
      width: width + 'px',
      minWidth: width + 'px',
      maxWidth: width + 'px',
      minHeight: height + 'px',
      maxHeight: height + 'px',
      '-webkit-border-radius': styleForRadius,
      '-moz-border-radius': styleForRadius,
      '-ms-border-radius': styleForRadius,
      'border-radius': styleForRadius
    }, false);
    KAMPYLE_UTILS.setElementStyle(divElement, {
      height: height + 'px',
      background: formData.buttonData.backgroundColor,
      color: formData.buttonData.textColor,
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: '-1'
    });

    var divElement2 = document.createElement('div');
    KAMPYLE_UTILS.addAttributesOnElement(divElement2, {
      'data-aut': 'feedback',
      class: 'kampyle_button-text'
    });
    KAMPYLE_UTILS.setElementStyle(divElement2, {
      fontWeight: 'normal'
    }, false);
    KAMPYLE_UTILS.setElementStyle(divElement2, {
      color: formData.buttonData.textColor,
      fontSize: fontSize + 'px',
      lineHeight: height + 'px',
      textAlign: 'center'
    });

    if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.RTL) && MDIGITAL_LOCALIZATION.isFormLanguageRtl(formData)) {
      KAMPYLE_UTILS.setElementStyle(divElement2, {
        transform: 'scale(-1)',
        '-ms-transform': 'scale(-1)',
        '-webkit-transform': 'scale(-1)'
      });
    }
    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ADDITIONAL_BUTTON_STYLES)){
        var defaultTextHoverColor = "#FFFFFF", defaultBackgroundHoverColor = "#396CEF";
        addHoverStyleToFeedbackButton(buttonElement,{
                bgElementStyle: {backgroundColor: formData.buttonData.backgroundColor},
                textElementStyle: {color: formData.buttonData.textColor}
            },
            {
                bgElementStyle: {backgroundColor: formData.buttonData.backgroundHoverColor || defaultBackgroundHoverColor},
                textElementStyle: {color: formData.buttonData.textHoverColor || defaultTextHoverColor}
            });
    }

    var textNode = document.createTextNode(buttonText);
    divElement2.appendChild(textNode);
    buttonElement.appendChild(divElement);
    buttonElement.appendChild(divElement2);
    return buttonElement
  }

  function addHoverStyleToFeedbackButton(parentElement, defaultStyles, onHoverStyles) {
      if (parentElement && defaultStyles && onHoverStyles && typeof (parentElement.addEventListener) === 'function') {
          parentElement.addEventListener("mouseenter", function () {
              var div1_bg = parentElement.children[0];
              var div2_text = parentElement.children[1];
              KAMPYLE_UTILS.setElementStyle(div1_bg, onHoverStyles.bgElementStyle);
              KAMPYLE_UTILS.setElementStyle(div2_text, onHoverStyles.textElementStyle);
          });
          parentElement.addEventListener("mouseleave", function () {
              var div1_bg = parentElement.children[0];
              var div2_text = parentElement.children[1];
              KAMPYLE_UTILS.setElementStyle(div1_bg, defaultStyles.bgElementStyle);
              KAMPYLE_UTILS.setElementStyle(div2_text, defaultStyles.textElementStyle);
          });
      }
  }

  function getPositionEnum(formData, btnSize) {
    return {
      topRight: {
        btnStyle: {top: 0, right: 0},
        div1Style: {
          top: 0,
          right: 0,
          borderTop: btnSize + ' solid ' + formData.buttonData.backgroundColor,
          borderLeft: btnSize + ' solid transparent'
        },
        div2Style: {
          '-ms-transform': 'rotate(45deg)',
          '-webkit-transform': 'rotate(45deg)',
          transform: 'rotate(45deg)'
        }
      },
      topLeft: {
        btnStyle: {top: 0, left: 0},
        div1Style: {
          top: 0,
          left: 0,
          borderTop: btnSize + ' solid ' + formData.buttonData.backgroundColor,
          borderRight: btnSize + ' solid transparent'
        },
        div2Style: {
          '-ms-transform': 'rotate(-45deg)',
          '-webkit-transform': 'rotate(-45deg)',
          transform: 'rotate(-45deg)'
        }
      },
      bottomRight: {
        btnStyle: {bottom: 0, right: 0},
        div1Style: {
          bottom: 0,
          right: 0,
          borderBottom: btnSize + ' solid ' + formData.buttonData.backgroundColor,
          borderLeft: btnSize + ' solid transparent'
        },
        div2Style: {
          '-ms-transform': 'rotate(-45deg)',
          '-webkit-transform': 'rotate(-45deg)',
          transform: 'rotate(-45deg)'
        }
      },
      bottomLeft: {
        btnStyle: {bottom: 0, left: 0},
        div1Style: {
          bottom: 0,
          left: 0,
          borderBottom: btnSize + ' solid ' + formData.buttonData.backgroundColor,
          borderRight: btnSize + ' solid transparent'
        },
        div2Style: {
          '-ms-transform': 'rotate(45deg)',
          '-webkit-transform': 'rotate(45deg)',
          transform: 'rotate(45deg)'
        }
      }
    };
  }
  function getMultiplier() {
    var z = KAMPYLE_UTILS.getZoomedIn();
    return z.constraint/z.zoom;
  }
  function getTriangularButton(formData) {
    var shouldAdjustToZoom = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.ENABLE_ZOOM_WCAG_REFLOW) && KAMPYLE_UTILS.getNestedPropertyValue(formData, 'urlVersion');
    var multiplier = shouldAdjustToZoom && KAMPYLE_UTILS.getZoomedIn().isZoomedIn? getMultiplier() : 1;
    var btnSize = 81*multiplier + 'px';
    var STYLE_BY_POSITION = getPositionEnum(formData, btnSize);
    var buttonElement = document.createElement('button');
    var buttonText = KAMPYLE_VIEW.getButtonText(formData);
    var position = formData.buttonData.position || 'topLeft';
    var classDirection = KAMPYLE_VIEW.getClassDirectonByPosition(position);
    var styleForBtn = STYLE_BY_POSITION[position].btnStyle;
    var styleForDiv1 = STYLE_BY_POSITION[position].div1Style;
    var styleForDiv2 = STYLE_BY_POSITION[position].div2Style;
    KAMPYLE_UTILS.addAttributesOnElement(buttonElement, {
      id: 'nebula_div_btn',
      alt: buttonText,
      tabindex: 0,
      class: 'kampyle_feedback-button ' + classDirection.leftright + ' ' + KAMPYLE_VIEW.getWCAGClass(),
    });

    KAMPYLE_UTILS.setElementStyle(buttonElement, {
      backgroundColor: 'transparent',
      height: 'auto',
      padding: 0
    }, false);
    KAMPYLE_UTILS.setElementStyle(buttonElement, Object.assign({
      fontFamily: 'Open Sans, sans-serif',
      cursor: 'pointer',
      position: 'fixed',
      border: 'none',
      zIndex: '99999990'
    }, styleForBtn));
    if (KAMPYLE_DATA.isFeatureEnabled(KAMPYLE_CONSTANT.FEATURE_FLAGS.WCAG)) {
      buttonElement.addEventListener("focusin", function (event) {
        KAMPYLE_UTILS.setElementStyle(buttonElement, {
          outline: '1px dashed #595959',
          outlineOffset: '2px',
          transition: 'none'
        }, false);
      });
      buttonElement.addEventListener("focusout", function (event) {
        buttonElement.style.outline = 'none';
        buttonElement.style.outlineOffset = null;
        buttonElement.style.transition = null;
      });
    } else {
      KAMPYLE_UTILS.setElementStyle(buttonElement, {
        outline: 'none'
      }, false);
    }
    var divElem1 = document.createElement('div');
    divElem1.setAttribute('class', 'kampyle_triangle');
    KAMPYLE_UTILS.setElementStyle(divElem1, Object.assign({
      position: 'absolute',
      width: 0,
      height: 0,
      zIndex: -1
    }, styleForDiv1));

    var divElem2 = document.createElement('div');
    KAMPYLE_UTILS.addAttributesOnElement(divElem2, {
      'data-aut': 'feedback',
      class: 'kampyle_button-text ' + classDirection.topbottom,
    });
    KAMPYLE_UTILS.setElementStyle(divElem2, {
      fontWeight: 'normal',
      lineHeight: (position === 'bottomLeft' || position === 'bottomRight') ? 108*multiplier + 'px' : 53*multiplier + 'px'
    }, false);
    KAMPYLE_UTILS.setElementStyle(divElem2, Object.assign({
      height: btnSize,
      width: btnSize,
      textAlign: 'center',
      zIndex: '1000',
      color: formData.buttonData.textColor,
      fontSize: 14*multiplier + 'px',
    }, styleForDiv2));

    var textNode = document.createTextNode(buttonText);
    divElem2.appendChild(textNode);
    buttonElement.appendChild(divElem1);
    buttonElement.appendChild(divElem2);
    return buttonElement;
  }

  function getCustomButton(formData) {
    var POSITION_ENUM = {
      bottomLeft: {bottom: 0, left: 0},
      bottomRight: {bottom: 0, right: 0},
      topLeft: {top: 0, left: 0},
      topRight: {top: 0, right: 0},
      left: {left: 0, top: '50%'},
      right: {right: 0, top: '50%'},
    }
    var buttonElement = document.createElement('button');
    var imgElem = document.createElement('img');
    var buttonText = KAMPYLE_VIEW.getButtonText(formData);
    var styleForBtn = POSITION_ENUM[formData.buttonData.position];
    KAMPYLE_UTILS.addAttributesOnElement(buttonElement, {
      id: 'nebula_div_btn',
      tabindex: 0,
      class: 'nebula_image_button ' + KAMPYLE_VIEW.getWCAGClass(),
    });
    KAMPYLE_UTILS.setElementStyle(buttonElement, {
      zIndex: '99999990',
      position: 'fixed',
      cursor: 'pointer',
      border: 'none',
      lineHeight: '1px',
      width: 'auto',
      background: 'transparent',
    }, false);
    KAMPYLE_UTILS.setElementStyle(buttonElement, Object.assign({
      padding: 0,
    }, styleForBtn));
    if (KAMPYLE_DATA.isFeatureEnabled(KAMPYLE_CONSTANT.FEATURE_FLAGS.WCAG)) {
      buttonElement.addEventListener("focusin", function (event) {
        KAMPYLE_UTILS.setElementStyle(buttonElement, {
          outline: '1px dashed #595959',
          outlineOffset: '2px',
          transition: 'none'
        }, false);
      });
      buttonElement.addEventListener("focusout", function (event) {
        buttonElement.style.outline = 'none';
        buttonElement.style.outlineOffset = null;
        buttonElement.style.transition = null;
      });
    } else {
      KAMPYLE_UTILS.setElementStyle(buttonElement, {
        outline: 'none'
      }, false);
    }
    KAMPYLE_UTILS.addAttributesOnElement(imgElem, {
      alt: buttonText,
      src: formData.buttonData.buttonUrl
    });
    buttonElement.appendChild(imgElem);
    return buttonElement;

  }

  function getErrorModalCloseButton(text, langCode) {
    var closeButton = document.createElement('i');
    
    KAMPYLE_UTILS.addAttributesOnElement(closeButton, {
      'aria-hidden': KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.NEW_MODAL_DIALOGS) ? false : true,
      tabIndex: KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.NEW_MODAL_DIALOGS) ? 0 : -1,
      id: 'close-no-json-modal',
      'data-aut': 'no-json-modal-close-button',
      role: "button",
      lang: langCode,
      'aria-label': text
    });
    
    KAMPYLE_UTILS.setElementStyle(closeButton, {
      cursor: 'pointer',
      position: 'absolute',
      top: '3px',
      right: '12px',
      fontStyle: 'normal',
      fontSize: '28px',
      opacity: 0.7
    });
    if (KAMPYLE_DATA.isFeatureEnabled(KAMPYLE_CONSTANT.FEATURE_FLAGS.WCAG)) {
      KAMPYLE_UTILS.addWcagStyleOnFocus(closeButton);
    }
    if (KAMPYLE_UTILS.isDesktop()) {
      KAMPYLE_UTILS.addHoverEffectOnElement(closeButton,{ opacity: 0.7}, { opacity: 1});
    }

    closeButton.innerHTML = "×";
    return closeButton;
  }

  function getErrorModalTitle(text) {
    var title = document.createElement('h2');
    KAMPYLE_UTILS.addAttributesOnElement(title, {
      id: "title-no-json-modal"
    });
    KAMPYLE_UTILS.setElementStyle(title, {
      fontWeight: 'bold',
      margin: '40px 0 16px',
      fontSize: '24px'
    })
    title.appendChild(document.createTextNode(text))
    return title;
  }

  function getErrorModalBackgroundImage() {
    var backgroundImage = document.createElement('img');
    KAMPYLE_UTILS.addAttributesOnElement(backgroundImage, {
      src: KAMPYLE_COMMON.getUrlPrefix() + KAMPYLE_CONSTANT.SRC.OOPS
    });
    KAMPYLE_UTILS.setElementStyle(backgroundImage, {
      marginLeft: '-1px'
    });

    return backgroundImage;
  }

  function getErrorModalDescription(text) {
    var container = document.createElement("div");
    KAMPYLE_UTILS.addAttributesOnElement(container, {
      id: "description-no-json-modal",
    });
    KAMPYLE_UTILS.setElementStyle(container, {
      padding: '0 44px',
      color: '#2C3548',
      fontFamily: 'helvetica',
      lineHeight: '23px',
      fontSize: '16px'
    });

    var description = document.createElement("p");
    description.innerHTML = text;

    container.appendChild(description);
    return container;
  }

  function createSpinnerElement() {
    var spinnerContainer = document.createElement('div');
    spinnerContainer.id = KAMPYLE_CONSTANT.SPINNER_SETTINGS.CONTAINER_ID;
    KAMPYLE_UTILS.addAttributesOnElement(spinnerContainer, {
      class: 'neb-loading-spinner'
    });
    var spinner = document.createElement('div');
    spinner.id = KAMPYLE_CONSTANT.SPINNER_SETTINGS.ID;
    spinnerContainer.appendChild(spinner);
    
    return spinnerContainer;
  }

  export default {
    createFormContainer: createFormContainer,
    createInviteIframeContainer: createInviteIframeContainer,
    getErrorModal: getErrorModal,
    getVerticalButton: getVerticalButton,
    getTriangularButton: getTriangularButton,
    getCustomButton: getCustomButton,
    addHoverStyleToFeedbackButton: addHoverStyleToFeedbackButton,
    createSpinnerElement: createSpinnerElement
  };
